import type { ListParams } from '@/shared/types';

export const regionKeys = {
  all: ['regions'] as const,
  list: (params: ListParams) => ['regions', 'list', params] as const,
  detail: (id: string | number) => ['regions', 'detail', id] as const,
  countries: ['regions', 'countries'] as const,
};
